import { GetPointRedemptionUsage_getPointRedemptionUsage } from "_graphql/queries/__generated__/getPointRedemptionUsage";
import { FC } from "react";

interface PointRedemptionViewProps {
  redemption: GetPointRedemptionUsage_getPointRedemptionUsage | null;
}

const PointRedemptionView: FC<PointRedemptionViewProps> = ({ redemption }) => {
  if (!redemption) return <div>No redemption data available</div>;

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-gray-900">
          Redemption Information
        </h3>
        <div className="mt-2 grid grid-cols-2 gap-4">
          <div>
            <p className="text-sm font-medium text-gray-500">Prize</p>
            <p className="mt-1 text-sm text-gray-900">{redemption.prize}</p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-500">Status</p>
            <p className="mt-1">
              <span
                className={`px-2 py-1 text-xs rounded-full ${
                  redemption.status === "REDEEMED"
                    ? "bg-green-100 text-green-800"
                    : redemption.status === "PENDING"
                    ? "bg-yellow-100 text-yellow-800"
                    : "bg-gray-100 text-gray-800"
                }`}
              >
                {redemption.status}
              </span>
            </p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-500">Voucher</p>
            <p className="mt-1 text-sm text-gray-900">{redemption.voucher}</p>
          </div>

          <div>
            <p className="text-sm font-medium text-gray-500">Created Date</p>
            <p className="mt-1 text-sm text-gray-900">
              {new Date(redemption.created_at).toLocaleString()}
            </p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-500">Updated Date</p>
            <p className="mt-1 text-sm text-gray-900">
              {new Date(redemption.updated_at).toLocaleString()}
            </p>
          </div>
        </div>
      </div>

      {redemption.redeemed_by && (
        <div>
          <h3 className="text-lg font-medium text-gray-900">Redeemed By</h3>
          <div className="mt-2 grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm font-medium text-gray-500">Name</p>
              <p className="mt-1 text-sm text-gray-900">
                {redemption.redeemed_by.assoc_first_name}{" "}
                {redemption.redeemed_by.assoc_last_name}
              </p>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Email</p>
              <p className="mt-1 text-sm text-gray-900">
                {redemption.redeemed_by.assoc_email}
              </p>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Phone</p>
              <p className="mt-1 text-sm text-gray-900">
                {redemption.redeemed_by.assoc_primary_phonenumber || "N/A"}
              </p>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Position</p>
              <p className="mt-1 text-sm text-gray-900">
                {redemption.redeemed_by.position || "N/A"}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PointRedemptionView;
